import * as _ from 'lodash';

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

export interface CSVField {
  label: string;
  value: string;
}
const replacer = (key: string, value: any) =>
  value === null || value === undefined ? '' : value;

function concat(src: string, newString: string, separator = ',') {
  return src ? `${src}${separator}${newString}` : newString;
}

// JSON to CSV Converter
export function downloadInCsv(
  fileName: string,
  objArray: any[],
  fields: CSVField[]
) {
  const header = _.reduce(
    fields,
    (result, field) => concat(result, field.label),
    ''
  );
  let body = '';
  objArray.forEach((data) => {
    let line = _.reduce(
      fields,
      (result, field) =>
        concat(result, JSON.stringify(data[field.value], replacer)),
      ''
    );
    body += line + '\r\n';
  });
  const csv = header + '\r\n' + body;
  let blob = new Blob([csv], { type: 'text/csv;charset=utf8;' });

  if (navigator.msSaveBlob) {
    let filename = fileName;
    navigator.msSaveBlob(blob, filename);
  } else {
    let link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('visibility', 'hidden');
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
